module.exports = __webpack_public_path__ + "fonts/Source_Sans_3-normal-700-greek.4d5ba9c.woff2";